module.exports = __webpack_public_path__ + "images/sprites/ui/circle_arrow_bu_a78019030e63b659f23c9521c2ca56ac.png";